module.exports = __webpack_public_path__ + "static/img/aBoxstrawberries.ec33706.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/aBoxstrawberries.jpg
// module id = zHjP
// module chunks = 1